const prefix = 'users'

export const UsersQueryKeys = {
  Users: `${prefix}/users`,
  UsersByIdentity: `${prefix}/users-by-identity`,
} as const
